import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { AppProvider } from './context/Store';
import Shell from './components/layout/Shell';
import Home from './pages/Home/Home';
import Missions from './pages/Missions/Missions';
import ContributionRoom from './pages/ContributionRoom/ContributionRoom';
import AIWorkforce from './pages/AIWorkforce/AIWorkforce';
import Placeholder from './pages/Placeholder';

function App() {
  return (
    <AppProvider>
      <HashRouter>
        <Routes>
          <Route path="/" element={<Shell />}>
            <Route index element={<Home />} />
            <Route path="missions" element={<Missions />} />
            <Route path="rooms" element={<ContributionRoom />} />
            <Route path="execution" element={<AIWorkforce />} />
            
            {/* Placeholders for other requested routes to demonstrate architecture completeness */}
            <Route path="decisions" element={<Placeholder />} />
            <Route path="experiments" element={<Placeholder />} />
            <Route path="performance" element={<Placeholder />} />
            <Route path="learning" element={<Placeholder />} />
            <Route path="people" element={<Placeholder />} />
            <Route path="search" element={<Placeholder />} />
            <Route path="settings" element={<Placeholder />} />
          </Route>
        </Routes>
      </HashRouter>
    </AppProvider>
  );
}

export default App;